/// <amd-module name="Core/Medius.Core.Web/Scripts/components/taskHandling/shared/modals/rejectManagementWizard/interfaces"/>
import { ListItem, SortInfo } from "@medius/ui-controls";

export enum RejectManagementWizardType {
    Delete,
    Invalidate,
    InvalidateAndEdit
}

export enum RejectionType {
    Delete,
    Invalidate
}

export enum RejectedEntityType {
    SupplierInvoice = "SupplierInvoice",
    EdiDocumentImport = "EdiDocumentImport",
    CaptureDocument = "CaptureDocument"
}

export interface IRejectManagementReasonCode {
    id: number;
    reasonCode: string;
    description: string;
    systemReasonCode: string;
    operations: string[];
    types: string[];
    isSystemReasonCode: boolean;
    rejectionActionId? : number | null
}

export interface IRejectionAction {
    id: number;
    code: string;
    name: string;
    description: string;
}

export interface ISupplierInvoiceRejectionDto {
    documentId: number;
    documentType: string;
    operation: string;
    task: string;
    rejectedEntityType: string;
    rejectionType: RejectionType;
    invoiceRejectionReasonItems: IInvoiceRejectionReasonItem[];
    hasExternalReasonCode: boolean;
    sendToSupplier: boolean;
    invoiceRejectionEmail?: IInvoiceRejectionEmailDto;
}

export interface IInvoiceRejectionEmailDto {
    emailTo: IRecipientAddress[];
    carbonCopy: IRecipientAddress[];
    sendCopy: boolean;
    messageSubject: boolean;
    content: string;
    attachments?: IUploadedAttachment[];
}

export interface IRecipientAddress {
    value: string;
}

export interface IInvoiceRejectionReasonItem{
    reasonCodeId: number;
    actionId?: number | null;
}

export interface IUploadedAttachment {
    hash: string;
    name: string;
    isDocumentImage: boolean;
}

export interface IInvoiceReasonCodeData {
    invoiceReasonCodes: IRejectManagementReasonCode[];
    forceReasonCode: boolean;
    totalInvoiceReasonCodeCount: number;
    actions: ListItem[];
    isLoading: boolean;
    isError: boolean;
    paging: {
        currentPage: number;
        pageSize: number;
        changePage: (newPage: number) => void;
        changePageSize: (newPageSize: number) => void;
    };
    sorting: {
        sortInfo: SortInfo | null;
        changeSortInfo: (sortInfo: SortInfo | null) => void;
    };
    searching: {
        changeSearchTerm: (term: string) => void;
    };
}

export interface IEmailSettings { 
    currentUserEmail : string;
    currentUserLanguageCode : string;
    supplierLanguageCode : string;
}

export interface IEmailContent {
    subject: string;
    body: string;
}

export interface IEligibleForEmailCommunication {
    isEligible: boolean;
}